import type { OvpClient } from '@bldsoft/cappie/api/ovp'
import type { API } from '@setplex/tria-api'
import type { AdapterDefaults } from '../../index.h'
import { payload } from '../../result'
import { format, formatSuggestion } from './format'
import type { ApiSearch, ApiSearchSuggestion } from './index.h'

export function use(
  client: OvpClient,
  search: API['search'],
  _api: API,
  _defaults: AdapterDefaults
): void {
  // GET /api/web/search
  search.base.getFx.use(async ({ q, limit }) => {
    const data = payload<ApiSearch>(
      await client.get.api.web.search({ query: { q, limit } })
    )

    if (!data) {
      throw new Error('Empty answer in search.base.getFx')
    }

    return format(data)
  })

  // GET /api/web/search/suggestion
  search.base.getSuggestionsFx.use(async ({ q, limit }) => {
    const data = payload<ApiSearchSuggestion>(
      await client.get.api.web.search.suggestion({ query: { q, limit } })
    )

    if (!data) {
      throw new Error('Empty answer in search.base.getSuggestionsFx')
    }

    return formatSuggestion(data)
  })
}
